<template>
    <div :class="['schedule-offer', styleTheme]">
        <div name="make-offer-from">
            <div class="make-offer content">
                <h4 v-html="makeOfferTitle" v-if="makeOfferTitle"></h4>
                <div class="amount-input-wrapper">
                    <input
                        name="price"
                        id="price"
                        class="amount-input"
                        type="tel"
                        v-model="price"
                        @input="onPriceInput($event)"
                        @keydown="onPriceKeydown($event)"
                        :placeholder="$t('md-detail-info.typeYourOfferAmount')"
                    />
                    <div v-show="priceEmpty" class="required-text-price">
                        {{ $t('md-detail-info.pleaseFillOutThis') }}
                    </div>
                </div>
                <div class="title-tip" v-html="additionalTitleLabel"></div>
                <div class="detail-input-wrapper">
                    <textarea
                        v-model="message"
                        id="message"
                        rows="4"
                        class="detail-input"
                    ></textarea>
                    <div v-show="msgEmpty" class="required-text-message">
                        {{ $t('md-detail-info.pleaseFillOutThis') }}
                    </div>
                </div>
            </div>
            <div class="footer">
                <button class="btn schedule-btn" @click="prepareOffer()">
                    {{ makeOfferButtonText }}
                </button>
            </div>
        </div>
    </div>
</template>

<script src="./schedule-offer.js"></script>
<style lang="scss">
@import '../../theme/mixin.scss';
@import '../../theme/media.scss';
.schedule-offer {
    .content {
        h4 {
            font-size: 16px;
            font-family: var(--font-title);
            color: var(--g-primary-color);
            line-height: 1.2;
            font-weight: 400;
            text-align: center;
            padding: 0 0 20px;
            @include media-600 {
                padding: 0 15px 20px;
            }
        }
        .amount-input,
        .detail-input {
            width: 100%;
            border: 1px solid rgba(218, 218, 218, 0.5);
            box-shadow: none;
            font-size: 14px;
            line-height: 1.2;
            padding: 10px 12px;
            color: var(--g-primary-color);
            background-color: var(--g-bg-color);
        }
        .title-tip {
            color: var(--g-primary-color);
            line-height: 1.3;
            margin-bottom: 10px;
        }
        .amount-input-wrapper,
        .detail-input-wrapper {
            margin-bottom: 20px;
        }
        .required-text-price,
        .required-text-message {
            line-height: 24px;
            color: var(--color-error);
        }
    }
    .footer {
        text-align: center;
        button {
            border: none;
            width: 100%;
            height: 40px;
            line-height: 40px;
            text-align: center;
            font-size: 16px;
            border-radius: 2px;
            @include color-button-v2();
            @include color-button-hover();
        }
    }
}
</style>
